import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import i18next from 'i18next';

export const WarningMessage = ({
  message,
  namespace = 'translations',
  translate = true,
  ...props
}) => {
  const { t } = useTranslation(['translations', 'errors']);
  return (
    <Typography role="alert" aria-live="assertive" color="error" variant="body2" {...props}>
      {translate ? t(message, { ns: namespace, lng: i18next.language }) : message}
    </Typography>
  );
};
